/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { useAppMandantContext } from "../Components/AppMandantContext";
import { environment } from "../environment";

export type ErmittleBuchungsportalUrlFunc = () => string;

export default function useErmittleBuchungsportalUrl(): ErmittleBuchungsportalUrlFunc {
    const appMandantContext = useAppMandantContext();

    function ermittleBuchungsportalUrl(): string {
        return `${environment.baseUrl}${appMandantContext.mandant?.urlBezeichnung}/buchungsportal`
    }

    return ermittleBuchungsportalUrl;
}